import { useImperativeHandle } from 'react';
import { useFormContext } from 'react-hook-form';

export type StepValidatorRef = {
  validate: () => Promise<boolean>;
};

export const useStepValidation = (ref: React.Ref<StepValidatorRef>, fields: string[]) => {
  const { trigger } = useFormContext();

  useImperativeHandle(ref, () => ({
    validate: () => trigger(fields),
  }));
};
